// Fetch categories from the API
import instance from "../../utils/axios";

export const getCategory = async (clientCode) => {
  try {
    if (!clientCode) {
      throw new Error("Client code is required.");
    }
    return await instance.get(`/categories/${encodeURIComponent(clientCode)}`);
  } catch (error) {
    console.error("Error fetching categories:", error.message);
    throw error; // Rethrow for further handling
  }
};
